import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 19.6",
  preserveAspectRatio: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  class: "elementor-shape-fill",
  style: {"opacity":".33"},
  d: "M0 0v18.8L141.8 4.1l141.7 14.7V0z"
}, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  class: "elementor-shape-fill",
  style: {"opacity":".33"},
  d: "M0 0v12.6L141.8 4l141.7 8.6V0z"
}, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  class: "elementor-shape-fill",
  style: {"opacity":".33"},
  d: "M0 0v6.4L141.8 4l141.7 2.4V0z"
}, null, -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  class: "elementor-shape-fill",
  d: "M0 0v1.2L141.8 4l141.7-2.8V0z"
}, null, -1 /* HOISTED */)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}
export default { render: render }